var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { useRoutePreload } from '@jetshop/core/hooks/useRoutePreload';
import { useHoverIntent } from './utils/useHoverIntent';
const CategoryLink = (_a) => {
    var { category: { id, name, primaryRoute }, children } = _a, props = __rest(_a, ["category", "children"]);
    const { preload } = useRoutePreload();
    const categoryPreload = () => {
        preload({
            pathname: primaryRoute && primaryRoute.path,
            routeType: 'Category'
        });
    };
    const [, intentRef] = useHoverIntent({
        onHover: () => {
            categoryPreload();
        }
    });
    return (React.createElement(NavLink, Object.assign({}, props, { to: {
            pathname: primaryRoute && primaryRoute.path,
            state: {
                type: 'Category',
                id
            }
        }, innerRef: intentRef, onTouchStart: categoryPreload }), children ? children : name));
};
export default CategoryLink;
//# sourceMappingURL=CategoryLink.js.map